export function getSessionInfo(item) {
  const userInfo = sessionStorage.getItem(item)
  if (userInfo && userInfo !== null) {
    return JSON.parse(userInfo)
  } else {
    return {}
  }
}

export function setSessionInfo(key, item) {
  return sessionStorage.setItem(key, JSON.stringify(item))
}